/**
 * Page instance id
 *
 * Will return 18 digit id generated only once.
 *
 */

let instanceId = null;

// Requirement for generated number should be similar to BIRF
const randomID = () => {
  const _padZeroes = (number, length) => {
    let str = '' + number;
    while (str.length < length) {
      str = '0' + str;
    }
    return str;
  };
  const t1 = new Date().getTime().toString().substr(2, 13);
  const r1 = _padZeroes(Math.floor(Math.random() * 10000000), 7);
  return t1 + r1;
};
export function getStaticId() {
  if (instanceId) {
    return instanceId;
  }
  instanceId = randomID();
  return instanceId;
}
export function resetStaticId() {
  instanceId = randomID();
  return instanceId;
}
export function getRandomId() {
  return randomID();
}
export default {
  getStaticId,
  resetStaticId,
  getRandomId
};